<div class="shell flex min-h-screen">
  @if (mobileMenuOpen()) {
    <button
      type="button"
      class="shell__backdrop"
      aria-label="Cerrar menú"
      (click)="closeMobileMenu()"
    ></button>
  }

  <aside
    class="shell__sidebar flex flex-column flex-none surface-border bg-transparent"
    [class.shell__sidebar--collapsed]="isRail()"
    [class.shell__sidebar--mobile-open]="mobileMenuOpen()"
  >
    @if (!isRail()) {
      <div class="p-3 surface-border">
        <img
          class="shell__brand-logo"
          [src]="theme.oscuro() ? 'assets/marca/mayorap-logo-blanco.png' : 'assets/marca/mayorap-logo-negro.png'"
          alt="Mayorap"
        />
        <div class="flex align-items-center gap-2">
          <span class="text-xs line-height-1 text-color-secondary">Administración</span>
          @if (etiquetaEntorno) {
            <p-tag [value]="etiquetaEntorno" severity="secondary" [rounded]="true" [style]="etiquetaEntornoStyle" />
          }
        </div>
        @if (userStore.vistaIglesia(); as vista) {
          <div class="text-xs line-height-1 text-primary mt-2">Viendo {{ vista }}</div>
        }
      </div>
    } @else {
      <div class="shell__brand-rail p-2">
        <img
          src="assets/marca/mayorap-isotipo.png"
          alt="Mayorap"
          [class.shell__brand-isotipo--claro]="theme.oscuro()"
        />
      </div>
    }

    <nav class="p-2" aria-label="Navegación principal">
      @if (userStore.isSuper()) {
        <div>
          @if (!isRail()) {
            <div class="shell__sectionTitle px-2 pt-4 pb-2 text-xs uppercase text-color-secondary">
              Super
            </div>
          } @else {
            <div
              class="flex align-items-center px-2 pt-4 pb-2 justify-content-center h-2rem text-xs font-bold text-color-secondary"
              aria-hidden="true"
            >
              Super
            </div>
          }

          <div class="flex flex-column gap-1">
            @for (item of superItems; track item.to) {
              <a
                class="shell__link flex align-items-center pl-4 gap-3 border-round-lg no-underline text-color-secondary"
                [class.justify-content-center]="isRail()"
                [class.px-0]="isRail()"
                [routerLink]="item.to"
                routerLinkActive="shell__link--active"
                [routerLinkActiveOptions]="{ exact: true }"
                [attr.aria-label]="isRail() ? item.label : null"
              >
                <i class="pi" [ngClass]="item.icon"></i>
                @if (!isRail()) {
                  <span class="font-medium">{{ item.label }}</span>
                }
              </a>
            }
          </div>
        </div>
      }

      @if (userStore.isAdmin()) {
        <div>
          @if (!isRail()) {
            <div class="shell__sectionTitle px-2 pt-4 pb-2 text-xs uppercase text-color-secondary">
              Administrador
            </div>
          } @else {
            <div
              class="flex align-items-center px-2 pt-4 pb-2 justify-content-center h-2rem text-xs font-bold text-color-secondary"
              aria-hidden="true"
            >
              Admin
            </div>
          }

          <div class="flex flex-column gap-1">
            @for (item of visibleAdminItems(); track item.to) {
              <a
                class="shell__link flex align-items-center pl-4 gap-3 border-round-lg no-underline text-color-secondary"
                [class.justify-content-center]="isRail()"
                [class.px-0]="isRail()"
                [routerLink]="item.to"
                routerLinkActive="shell__link--active"
                [routerLinkActiveOptions]="{ exact: true }"
                [attr.aria-label]="isRail() ? item.label : null"
              >
                <i class="pi" [ngClass]="item.icon"></i>
                @if (!isRail()) {
                  <span class="font-medium">{{ item.label }}</span>
                }
              </a>
            }
            @if (listaAdmin() && !userStore.isLider()) {
              <a
                class="shell__link flex align-items-center pl-4 gap-3 border-round-lg no-underline text-color-secondary"
                [class.justify-content-center]="isRail()"
                [class.px-0]="isRail()"
                routerLink="/tomar-lista"
                routerLinkActive="shell__link--active"
                [routerLinkActiveOptions]="{ exact: true }"
                [attr.aria-label]="isRail() ? 'Tomar lista' : null"
              >
                <i class="pi pi-check-square"></i>
                @if (!isRail()) {
                  <span class="font-medium">Tomar lista</span>
                }
              </a>
            }
          </div>
        </div>
      }

      @if (userStore.isLider()) {
        <div>
          @if (!isRail()) {
            <div class="shell__sectionTitle px-2 pt-4 pb-2 text-xs uppercase text-color-secondary">
              Líder
            </div>
          } @else {
            <div
              class="flex align-items-center px-4 pt-4 pb-2 justify-content-center h-2rem text-xs font-bold text-color-secondary"
              aria-hidden="true"
            >
              Lider
            </div>
          }

          <div class="flex flex-column gap-1">
            @if (graficosHabilitados()) {
              <a
                class="shell__link flex align-items-center pl-4 gap-3 border-round-lg no-underline text-color-secondary"
                [class.justify-content-center]="isRail()"
                [class.px-0]="isRail()"
                routerLink="/graficos"
                routerLinkActive="shell__link--active"
                [routerLinkActiveOptions]="{ exact: true }"
                [attr.aria-label]="isRail() ? 'Gráficos' : null"
                data-testid="nav-graficos-lider"
              >
                <i class="pi pi-chart-bar"></i>
                @if (!isRail()) {
                  <span class="font-medium">Gráficos</span>
                }
              </a>
            }
            @for (item of visibleLeaderItems(); track item.to) {
              <a
                class="shell__link flex align-items-center pl-4 gap-3 border-round-lg no-underline text-color-secondary"
                [class.justify-content-center]="isRail()"
                [class.px-0]="isRail()"
                [routerLink]="item.to"
                routerLinkActive="shell__link--active"
                [routerLinkActiveOptions]="{ exact: true }"
                [attr.aria-label]="isRail() ? item.label : null"
              >
                <i class="pi" [ngClass]="item.icon"></i>
                @if (!isRail()) {
                  <span class="font-medium">{{ item.label }}</span>
                }
              </a>
            }
          </div>
        </div>
      }

      @if (userStore.isContador()) {
        <div>
          @if (!isRail()) {
            <div class="shell__sectionTitle px-2 pt-4 pb-2 text-xs uppercase text-color-secondary">
              Contador
            </div>
          } @else {
            <div
              class="flex align-items-center px-1 pt-4 pb-2 justify-content-center h-2rem text-xs font-bold text-color-secondary overflow-hidden white-space-nowrap"
              aria-hidden="true"
            >
              Contador
            </div>
          }

          <div class="flex flex-column gap-1">
            @for (item of contadorItems(); track item.to) {
              <a
                class="shell__link flex align-items-center pl-4 gap-3 border-round-lg no-underline text-color-secondary"
                [class.justify-content-center]="isRail()"
                [class.px-0]="isRail()"
                [routerLink]="item.to"
                routerLinkActive="shell__link--active"
                [routerLinkActiveOptions]="{ exact: true }"
                [attr.aria-label]="isRail() ? item.label : null"
              >
                <i class="pi" [ngClass]="item.icon"></i>
                @if (!isRail()) {
                  <span class="font-medium">{{ item.label }}</span>
                }
              </a>
            }
          </div>
        </div>
      }
    </nav>

    <div class="mt-auto p-2 border-top-1 surface-border">
      <p-button
        type="button"
        icon="pi pi-sign-out"
        label="Salir"
        (onClick)="logout()"
        styleClass="p-button-text w-full"
      />
    </div>
  </aside>

  <main class="flex-1 min-w-0 flex flex-column">
    <header class="flex align-items-center justify-content-between px-3 md:px-8 py-2 surface-border bg-transparent">
      <div class="flex align-items-center gap-2 min-w-0">
        <button
          type="button"
          class="shell__header-btn flex align-items-center justify-content-center border-round-lg text-color-secondary"
          aria-label="Alternar menú"
          (click)="toggleSidebar()"
        >
          <i class="pi pi-bars" aria-hidden="true"></i>
        </button>
        <div class="font-semibold line-height-1">{{ pageTitle() }}</div>
      </div>

      <div class="flex align-items-center gap-1">
        <app-instalar-app-boton class="mr-1" />
        @if (userStore.email()) {
          <span class="hidden md:inline text-sm text-color-secondary mr-2">{{ userStore.email() }}</span>
        }
        <!-- Mi perfil: oculto hasta definir su funcionamiento.
        <a
          routerLink="/perfil"
          class="shell__header-btn flex align-items-center justify-content-center border-round-lg no-underline text-color-secondary"
          [class.shell__header-btn--active]="isPerfilActive()"
          aria-label="Ir a perfil"
        >
          <i class="pi pi-user" aria-hidden="true"></i>
        </a>
        -->
        <button
          type="button"
          class="shell__header-btn flex align-items-center justify-content-center border-round-lg text-color-secondary"
          [attr.aria-label]="theme.oscuro() ? 'Usar tema claro' : 'Usar tema oscuro'"
          [attr.aria-pressed]="theme.oscuro()"
          (click)="theme.alternar()"
        >
          <i class="pi" [class.pi-sun]="theme.oscuro()" [class.pi-moon]="!theme.oscuro()" aria-hidden="true"></i>
        </button>
        <a
          routerLink="/configuracion"
          class="shell__header-btn flex align-items-center justify-content-center border-round-lg no-underline text-color-secondary"
          [class.shell__header-btn--active]="isConfiguracionActive()"
          aria-label="Ir a configuración"
        >
          <i class="pi pi-cog" aria-hidden="true"></i>
        </a>
      </div>
    </header>

    <div class="flex-1 min-w-0 p-3 md:px-8" [class.shell__content--flush]="sinPaddingEnMobile()">
      <div class="shell__page" [@routeFade]="pageFade()">
        <router-outlet />
      </div>
    </div>
  </main>
</div>
